/**
 * @generated SignedSource<<98eed4da10a5e57bb9f354185fb5dc1a>>
 * @relayHash a0d3a8ec0c248b77578731d611b9af73
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5e2df9aae101b29a842b46a4953acb38e0a6784032857c79f58109989cf58405

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessOverviewCalendarQuery } from './src_jiraBusinessOverviewCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessOverviewCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5e2df9aae101b29a842b46a4953acb38e0a6784032857c79f58109989cf58405",
    "metadata": {},
    "name": "src_jiraBusinessOverviewCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
